import contactBox from './contactBox.vue'
export default contactBox